import { render, staticRenderFns } from "./Tzgmrk.vue?vue&type=template&id=7e8bff90&scoped=true&"
import script from "./Tzgmrk.vue?vue&type=script&lang=js&"
export * from "./Tzgmrk.vue?vue&type=script&lang=js&"
import style0 from "./Tzgmrk.vue?vue&type=style&index=0&id=7e8bff90&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e8bff90",
  null
  
)

export default component.exports